import script from "./AppBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBar.vue?vue&type=script&setup=true&lang=ts"

import "./AppBar.vue?vue&type=style&index=0&id=ff8132da&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff8132da"]])